import { zip } from 'lodash'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import AnalyticsSample, { validateSampleField } from '@modules/admin/analytics/Analytics.SampleFilter'
import { barDataParser, labelsDoughnutPercentatge } from '@modules/admin/analytics/utils'
import ExportCsv from '@modules/admin/shared/ExportCsv'
import Title from '@modules/admin/shared/Title'
import AccessControl from '@modules/auth/AccessControl'
import Loading from '@modules/core/components/Loading'
import AsyncProfessionalField from '@modules/formFields/AsyncProfessionalField'
import SelectAppRolesField from '@modules/formFields/SelectAppRolesField'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import SelectSpecialityField from '@modules/formFields/SelectSpecialityField'
import moment from 'moment'
import React, { Component } from 'react'
import { Bar, Doughnut, Line } from 'react-chartjs-2'
import { Trans, withTranslation } from 'react-i18next'
import { compose } from 'redux'
import { Field, Form, reduxForm } from 'redux-form/dist/redux-form'
import Professional from '@services/Professional'
import { barDataParserCake, doughnutDataParser, lineDataParserTotal } from './utils'
import { PROVIDER_ADMIN, PAAS_ADMIN, SUPER_ADMIN } from '@constants/adminRoles'

class AnalyticsQos extends Component {
  state = {
    evolutionScoreBarChart: undefined,
    evolutionScoreLineChart: undefined,
    customerSatisfactionEvolutionChart: undefined,
    evolutionReviewLineChart: undefined,
    doughnutNpsChart: undefined,
    doughnutSatisfactionChart: undefined,
  }

  client = Professional.analytics

  fetchEvolutionScoreChart = (values) => {
    const filters = {
      startDate:
        values.sample.startDate && moment(values.sample.startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      endDate: values.sample.endDate && moment(values.sample.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      sampleRate: values.sample.sampleRate && values.sample.sampleRate,
      apiKeys: values.companyFilter && values.companyFilter.map((co) => co.api_key).join(','),
      specialityFilter: values.specialityFilter && values.specialityFilter.map((sp) => sp.id).join(','),
      professionalFilter: values.professionalFilter && values.professionalFilter.hash,
      appRoleFilter: values.appRoleFilter,
    }

    return Promise.all([
      this.client
        .getEvolutionScoreChart(filters)
        .then((response) => {
          let line = { ...response, datasets: response.datasets.filter((set) => set.type === 'line') }
          let bar = { ...response, datasets: response.datasets.filter((set) => set.type === 'bar') }
          this.setState({ evolutionScoreBarChart: bar, evolutionScoreLineChart: line })
        })
        .catch((e) => {
          this.setState({ evolutionScoreBarChart: undefined, evolutionScoreLineChart: undefined })
          window.alert(JSON.stringify(e.message, null, 2))
        }),

      this.client
        .getCustomerSatisfactionEvolutionChart(filters)
        .then((response) => {
          this.setState({ customerSatisfactionEvolutionChart: response })
        })
        .catch((e) => {
          this.setState({ customerSatisfactionEvolutionChart: undefined })
          window.alert(JSON.stringify(e.message, null, 2))
        }),

      this.client
        .getEvolutionAvgReviewChart(filters)
        .then((response) => {
          this.setState({ evolutionReviewLineChart: response })
        })
        .catch((e) => {
          this.setState({ evolutionReviewLineChart: undefined })
          window.alert(JSON.stringify(e.message, null, 2))
        }),

      this.client
        .getDoughnutNpsChart(filters)
        .then((response) => {
          this.setState({ doughnutNpsChart: response })
        })
        .catch((e) => {
          this.setState({ doughnutNpsChart: undefined })
          window.alert(JSON.stringify(e.message, null, 2))
        }),

      this.client
        .getDoughnutSatisfactionChart(filters)
        .then((response) => {
          this.setState({ doughnutSatisfactionChart: response })
        })
        .catch((e) => {
          this.setState({ doughnutSatisfactionChart: undefined })
          window.alert(JSON.stringify(e.message, null, 2))
        }),
    ])
  }

  componentDidMount() {
    setTimeout(this.props.submit, 0)
  }

  render() {
    const {
      evolutionScoreBarChart,
      evolutionScoreLineChart,
      customerSatisfactionEvolutionChart,
      evolutionReviewLineChart,
      doughnutNpsChart,
      doughnutSatisfactionChart,
    } = this.state
    const { handleSubmit, submitting } = this.props
    const optionsDoughnut = {
      tooltips: {
        callbacks: {
          label: labelsDoughnutPercentatge,
        },
      },
      legend: { display: false },
    }
    return (
      <div className="analytics-container">
        <DashboardHeader title={<Trans>Calidad del servicio</Trans>} />

        <Form className="container-filters-extended" onSubmit={handleSubmit(this.fetchEvolutionScoreChart)}>
          <div className="filter-extended">
            <Field name="sample" component={AnalyticsSample} validate={validateSampleField} />
            <AccessControl role="super-admin">
              <Field name="companyFilter" multi component={SelectCompanyField} />
            </AccessControl>
            <AccessControl roles={[SUPER_ADMIN, PAAS_ADMIN, PROVIDER_ADMIN]}>
              <Field name="appRoleFilter" component={SelectAppRolesField} simpleValue />
            </AccessControl>
            <Field name="specialityFilter" multi component={SelectSpecialityField} />
            <Field name="professionalFilter" component={AsyncProfessionalField} />
            {this.props.error && (
              <span style={{ color: 'red' }} className="error">
                {this.props.error}
              </span>
            )}
          </div>
          <div className="container-apply-filters">
            <button className="apply-filters">
              <Trans>Aplicar filtros</Trans>
            </button>
          </div>
        </Form>

        <Loading isFetching={submitting} />

        {evolutionScoreBarChart && (
          <div className="chart-container">
            <Title title={<Trans>Evolución Net Promoter Score</Trans>}>
              <ExportCsv
                data={zip(
                  evolutionScoreBarChart.dates,
                  ...evolutionScoreBarChart.datasets.map((dataset) => dataset.data)
                )}
                headers={['Fecha', ...evolutionScoreBarChart.datasets.map((el) => el.label)]}
                filename={'Evolución_net_promoter_score.csv'}
              />
            </Title>

            <Bar
              data={barDataParserCake(evolutionScoreBarChart)}
              height={70}
              options={{
                scales: {
                  xAxes: [
                    {
                      stacked: true,
                    },
                  ],
                  yAxes: [
                    {
                      stacked: true,
                    },
                  ],
                },
              }}
            />
          </div>
        )}

        {evolutionScoreLineChart && (
          <div className="chart-container">
            <Title title={<Trans>Evolución Net Promoter Score Acumulados</Trans>}>
              <ExportCsv
                data={zip(
                  evolutionScoreLineChart.dates,
                  ...evolutionScoreLineChart.datasets.map((dataset) => dataset.data)
                )}
                filename={'Evolución_net_promoter_score_acumulado.csv'}
                headers={['Fecha', ...evolutionScoreLineChart.datasets.map((el) => el.label)]}
              />
            </Title>
            <Line data={lineDataParserTotal(evolutionScoreLineChart)} height={70} />
          </div>
        )}

        {customerSatisfactionEvolutionChart && (
          <div className="chart-container">
            <Title title={<Trans>Evolución de la Satisfacción de Usuario</Trans>}>
              <ExportCsv
                data={zip(
                  customerSatisfactionEvolutionChart.dates,
                  ...customerSatisfactionEvolutionChart.datasets.map((dataset) => dataset.data)
                )}
                filename={'Evolución_de_la_satisfacción_de_usuario.csv'}
                headers={['Fecha', ...customerSatisfactionEvolutionChart.datasets.map((el) => el.label)]}
              />
            </Title>
            <Bar
              data={barDataParser(customerSatisfactionEvolutionChart)}
              options={{
                scales: {
                  xAxes: [
                    {
                      stacked: true,
                    },
                  ],
                  yAxes: [
                    {
                      stacked: true,
                    },
                  ],
                },
              }}
              height={70}
            />
          </div>
        )}

        {evolutionReviewLineChart && (
          <div className="chart-container">
            <Title title={<Trans>Evolución en la Valoración de las Revisiones</Trans>}>
              <ExportCsv
                data={zip(evolutionReviewLineChart.dates, evolutionReviewLineChart.data)}
                filename={'Evolución_en_la_valoración_de_las_revisiones.csv'}
                headers={['Fecha', evolutionReviewLineChart.label]}
              />
            </Title>
            <Line data={barDataParser(evolutionReviewLineChart)} height={70} />
          </div>
        )}

        <div className="container-dognuts chart-container">
          {doughnutNpsChart && (
            <div className="dognut-box">
              <Title title={<Trans>Net Promoter Score</Trans>} total={doughnutNpsChart.total} />
              <Doughnut data={doughnutDataParser(doughnutNpsChart)} options={optionsDoughnut} />
            </div>
          )}

          {doughnutSatisfactionChart && (
            //SORRY FOR THIS (d => (100 * (d[0] - d[2]) / (d[0] + d[1] + d[2])))(doughnutSatisfactionChart.data) ,
            //this is a 1line function with argument d , and is executed on the same line with (doughnutSatisfactionChart.data)
            <div className="dognut-box">
              <Title title={<Trans>Satisfacción del Usuario</Trans>} total={doughnutSatisfactionChart.total} />
              <Doughnut data={doughnutDataParser(doughnutSatisfactionChart)} options={optionsDoughnut} />
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default compose(
  withTranslation(),
  reduxForm({
    form: 'analytics',
    initialValues: {
      sample: {
        startDate: moment().startOf('week').toDate(),
        endDate: moment().toDate(),
        sampleRate: 'hour',
        id: 'custom',
      },
      companyFilter: [],
    },
    validate: (values) => ({ _error: validateSampleField(values.sample) }),
    destroyOnUnmount: false,
  })
)(AnalyticsQos)
